import { checkerRegions } from "../data/checker-addresses.js";

/**
 * The checker IP addresses per region, from `src/data/checker-addresses.ts`.
 */
export function CheckerAddresses() {
  return (
    <table>
      <thead>
        <tr>
          <th>Region</th>
          <th>Location in the API</th>
          <th>IP addresses</th>
        </tr>
      </thead>
      <tbody>
        {checkerRegions.map((region) => (
          <tr key={region.location}>
            <td>{region.name}</td>
            <td>
              <code>{region.location}</code>
            </td>
            <td className="font-mono">
              {[...region.ipv4, ...region.ipv6].map((address) => (
                <div key={address}>{address}</div>
              ))}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
